import React from 'react';
import PropTypes from 'prop-types';
import styleable from 'react-styleable';
import { injectIntl, intlShape } from 'react-intl';
import { Edit, Download } from '../../helpers/icon-dictionary';
import css from './index.scss';
import messages from './messages';
import StudentCount from '../student-count/index';
import Button from '../../components/button/index';
import productEnum from '../../helpers/product-enum';
import Modal from '../../components/modal/index';
import SignInCardsFormats from '../sign-in-cards-formats';
import { getNewCoursesTitle } from '../../helpers/utils';

const ClassroomGroupList = ({
    intl,
    classroomDetail,
    downloadStudentSignInCards,
    isDownloadingSignInCards,
    handleOnEditGroup,
    openAddGroup,
    selectedProduct,
    handleOnStudentSignInCards,
    handleOnCancelStudentSignInCards,
    showHideSignInCardModal = false,
    displayNewCourses,
    yearGroup
}) => {
    const getUPFCourseTitle = ({ isOptedOut, upfCourseId, upfCourseTitle }) => {
        if (upfCourseId !== 0) {
            return upfCourseTitle;
        }

        if (isOptedOut) {
            return intl.formatMessage(messages.optedOut);
        }

        return intl.formatMessage(messages.noVoluntaryCourseSet);
    };

    return (
        <div>
            <div>
                <div className={css.header}>
                    <div className={css.columns}>{intl.formatMessage(messages.group)}</div>
                    <div className={css.columns}>
                        {selectedProduct.id !== productEnum.MATLETICA.id && (
                            <span>{intl.formatMessage(messages.activities).toUpperCase()}</span>
                        )}
                    </div>
                    {
                        displayNewCourses && <div className={css.columns}>
                            {selectedProduct.id !== productEnum.MATLETICA.id && (
                                <span>{intl.formatMessage(messages.newCourses).toUpperCase()}</span>
                            )}
                        </div>
                    }
                    <div className={css.newCoursesColumn}>
                        {selectedProduct.id === productEnum.MATHLETICS.id && (
                            <span>{intl.formatMessage(messages.skillQuests).toUpperCase()}</span>
                        )}
                    </div>
                    <div className={css.studentColumn}>{intl.formatMessage(messages.students)}</div>
                    <div className={css.editColumn}>{}</div>
                </div>
                {
                    classroomDetail.classroomGroups.map((classGroup) => {
                        const { conquestCourseTitle } = classGroup;
                        return (<div className={css.list} key={classGroup.id}>
                            <div className={css.columns}>{classGroup.name}</div>
                            <div className={css.columns}>
                                {selectedProduct.id !== productEnum.MATLETICA.id && (
                                    <span>{classGroup.courseTitle}</span>
                                )}
                            </div>
                            {
                                displayNewCourses && <div className={css.columns}>
                                    {selectedProduct.id !== productEnum.MATLETICA.id && (
                                        <span>{getNewCoursesTitle(yearGroup, conquestCourseTitle !== '', conquestCourseTitle, intl)}</span>
                                    )}
                                </div>
                            }
                            <div className={css.columns}>
                                { selectedProduct.id === productEnum.MATHLETICS.id && getUPFCourseTitle(classGroup) }
                            </div>

                            <div className={css.studentColumn}><StudentCount
                                count={classGroup.studentIds.length}
                                icon={css.studentCountIcon} /></div>
                            <div className={css.editColumn}>
                                <Button
                                    containerClassName={`editClassGroupBtn ${css.buttonContainerStyle}`}
                                    handleOnClick={() => handleOnEditGroup(classGroup)}
                                    icon={Edit}
                                    iconClassName={css.icon} />
                            </div>
                        </div>
                        );
                    })
                }
                <div className={css.footer}>
                    <Button
                        containerClassName={css.downloadSignInCards}
                        disabled={classroomDetail.studentsProfileId.length === 0}
                        handleOnClick={handleOnStudentSignInCards}
                        icon={Download}
                        iconClassName={css.icon}
                        label={intl.formatMessage(messages.downloadCards)} />
                    <Button
                        containerClassName={css.createGroup}
                        handleOnClick={openAddGroup}
                        icon={Edit}
                        iconClassName={css.icon}
                        label={intl.formatMessage(messages.createGroup)} />
                </div>
            </div>
            <Modal show={showHideSignInCardModal}>
                <SignInCardsFormats
                    handleOnCancel={handleOnCancelStudentSignInCards}
                    handleOnDownloadSignInCards={downloadStudentSignInCards}
                    isSignInCardDownloaded={!isDownloadingSignInCards} />
            </Modal>
        </div>
    );
};

ClassroomGroupList.propTypes = {
    intl: intlShape.isRequired,
    classroomDetail: PropTypes.object,
    yearGroup: PropTypes.number,
    downloadStudentSignInCards: PropTypes.func,
    isDownloadingSignInCards: PropTypes.bool,
    handleOnEditGroup: PropTypes.func,
    openAddGroup: PropTypes.func,
    selectedProduct: PropTypes.object,
    handleOnStudentSignInCards: PropTypes.func,
    handleOnCancelStudentSignInCards: PropTypes.func,
    showHideSignInCardModal: PropTypes.bool,
    displayNewCourses: PropTypes.bool
};

export default injectIntl(styleable(css)(ClassroomGroupList));



// WEBPACK FOOTER //
// ./app/components/classroom-group-list/index.js